/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../core/AppDispatcher'
import { List } from 'immutable'
import { AuditState } from './state/AuditState'
import ReservationEvent from '../event/ReservationEvent'

class AuditsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchAuditLog:
        const audits = payload.response.map(audit => new AuditState(audit))
        return List(audits)
      default:
        return state
    }
  }
}

export default new AuditsStore()
